<template>
    <div>
        <router-link :to="{ hash: '#projektcontrolling' }" @click.native="$moveToAnchor('#projektcontrolling')">
            <article class="message" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
                <div class="message-header message-header-color-3 is-size-5-custom message-header-center has-text-centered" :class="{ 'min-text-height-message': !this.isTablet, 'min-text-height-message-custom-tablet': this.isTablet }">
                    <p>{{ $t('kmso.project_management.main_box_3_title') }}</p>
                </div>
                <div class="message-body is-size-5-custom">
                    <figure class="image is-3by2">
                        <img src="/img/projektmanagement3.svg" :alt="$t('kmso.project_management.main_box_3_title')">
                    </figure>
                </div>
                <div class="message-footer message-header-color-3 is-size-5-custom">
                    <div class="is-vertical-center add-horizontal-center message-min-text-footer-height">
                        <p class="link-text">
                            {{ $t('kmso.general.learn_more') }}
                        </p>
                    </div>
                </div>
            </article>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Projektmanagement-3',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
